<script lang="ts">
  import { Button } from '$lib/components/ui/button';

  // Shared by ConversationPane.svelte (Messaging) and CommentThreadPanel.svelte (Comments) --
  // resolving a display label for the pinned item's author differs between the two (a ChatMessage
  // only carries sender_id and needs a participant lookup + "You" special-case; a Comment already
  // carries a resolved `author` object), so the caller resolves {id, label, preview} itself before
  // handing it down here, same convention as ThreadComposer's replyTo prop.
  type PinnedEntry = { id: string; label: string; preview: string };

  export let pinned: PinnedEntry[];
  export let noun: 'message' | 'comment' = 'message';
  export let onUnpin: (id: string) => void = () => {};
  export let onJumpTo: (id: string) => void = () => {};

  let expanded = false;

  $: plural = noun === 'message' ? 'messages' : 'comments';
</script>

{#if pinned.length > 0}
  <div class="shrink-0 border-b border-border bg-muted/30">
    <Button
      variant="ghost"
      class="h-auto w-full justify-start gap-2 rounded-none px-4 py-1.5 text-xs font-normal text-muted-foreground hover:text-foreground"
      on:click={() => (expanded = !expanded)}
    >
      <span class="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <i class="fa-solid fa-thumbtack text-[9px]"></i>
      </span>
      <span>{pinned.length} pinned {pinned.length === 1 ? noun : plural}</span>
      <i class="fa-solid ml-auto text-[10px] transition-transform {expanded ? 'fa-chevron-up' : 'fa-chevron-down'}"></i>
    </Button>
    {#if expanded}
      <div class="max-h-40 overflow-y-auto border-t border-border/60">
        {#each pinned as entry, i (entry.id)}
          <div class="group flex items-center gap-1 {i > 0 ? 'border-t border-border/40' : ''} pr-1.5">
            <Button
              variant="ghost"
              class="h-auto min-w-0 flex-1 justify-start rounded-none px-4 py-1.5 text-left text-xs font-normal"
              on:click={() => onJumpTo(entry.id)}
            >
              <span class="block min-w-0 truncate">
                <span class="font-medium text-foreground">{entry.label}: </span>
                <span class="text-muted-foreground">{entry.preview}</span>
              </span>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              class="h-6 w-6 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100 hover:text-foreground"
              title="Unpin"
              on:click={() => onUnpin(entry.id)}
            >
              <i class="fa-solid fa-thumbtack-slash text-[11px]"></i>
            </Button>
          </div>
        {/each}
      </div>
    {/if}
  </div>
{/if}
